import Swal from "sweetalert2";
import PropTypes from 'prop-types';
import { Col } from 'react-bootstrap';
import styled from 'styled-components';
import EditIcon from 'mdi-react/EditIcon';
import DeleteIcon from 'mdi-react/DeleteIcon';
import React, { useEffect, useState } from 'react';
import AdminInterface from '@/utils/AdminInterface';
import withReactContent from "sweetalert2-react-content";
import { paddingLeft, paddingRight } from '@/utils/directions';
import { colorAdditional, colorGreenHover } from '@/utils/palette';
import ReactTableBase from '@/shared/components/table/ReactTableBase';
import { Card, CardBody, CardTitleWrap, CardTitle } from '@/shared/components/Card';

const CartTableButton = styled.button`
  background: transparent;
  border: none;
  line-height: 14px;
  ${paddingLeft}: 20px;
  ${paddingRight}: 0;
  padding-top: 0;
  padding-bottom: 0;
  color: ${colorAdditional};
  cursor: pointer;
  transition: all 0.3s;

  svg {
    height: 20px;
    width: 20px;
    fill: ${colorAdditional};
    transition: all 0.3s;
  }

  svg:hover {
    fill: ${colorGreenHover};
  }

  .orange-hover:hover {
    fill: #e9c886;
  }

  .red-hover:hover {
    fill: #e98686;
  }
`;

const CropRequestPricesList = (props) => {
    const [cropRequestPricesList, setCropRequestPricesList] = useState({ tableHeaderData: [], tableRowsData: [] });
    const tableConfig = {
        isEditable: false,
        isSortable: true,
        isResizable: false,
        withPagination: false,
        withSearchEngine: false
    };

    const handleEdit = (price) => {
        props.setEditCropRequestPrice(price);
    }

    const handleDelete = (price) => {
        AdminInterface.instance.deleteCropRequestPrice(price.collection_id, price.resolution).then((response) => {
            withReactContent(Swal).fire({
                title: "Success",
                html: "Crop request price is deleted!",
            });
            props.setListRequiresReload(true);
        }).catch((error) => {
            withReactContent(Swal).fire({
                title: "Error",
                html: error.response?.data?.detail,
            });
        });
    }

    const GetCropRequestPricesData = () => {
        AdminInterface.instance.getCropRequestPrices().then((response) => {
            const columns = [
                {
                    accessor: 'collection',
                    Header: 'Collection',
                },
                {
                    accessor: 'resolution',
                    Header: 'Resolution',
                },
                {
                    accessor: 'oldAssetPrice',
                    Header: 'Old Assets Price (CAD ¢/KM2)',
                    disableSortBy: true,
                },
                {
                    accessor: 'newAssetPrice',
                    Header: 'New Assets Price (CAD ¢/KM2)',
                    disableSortBy: true,
                },
                {
                    accessor: 'edit',
                    Header: 'Edit',
                    disableGlobalFilter: true,
                    disableSortBy: true,
                },
                {
                    accessor: 'delete',
                    Header: 'Delete',
                    disableGlobalFilter: true,
                    disableSortBy: true,
                }
            ];
            const data = [];
            response.data.forEach(price => {
                data.push({
                    collection: price.collection.name,
                    resolution: price.resolution,
                    oldAssetPrice: price.oldAssetPrice,
                    newAssetPrice: price.newAssetPrice,
                    edit: <CartTableButton type="button" onClick={() => handleEdit(price)}><EditIcon className="orange-hover"/></CartTableButton>,
                    delete: <CartTableButton type="button" onClick={() => handleDelete(price)}><DeleteIcon className="red-hover"/></CartTableButton>,
                });
            });

            const cropRequestPricesListTableData = { tableHeaderData: columns, tableRowsData: data };
            setCropRequestPricesList(cropRequestPricesListTableData);
        }).catch((error) => {
            withReactContent(Swal).fire({
                title: "Error",
                html: error.response.data?.detail,
            });
        }).finally(() => {
            props.setListRequiresReload(false);
        });
    };

    useEffect(() => {
        GetCropRequestPricesData();
    }, [props.listRequiresReload]);

    return (
        <Col md={12} lg={12}>
            <Card>
                <CardBody>
                    <CardTitleWrap>
                        <CardTitle>Crop Request Prices list</CardTitle>
                    </CardTitleWrap>
                    <ReactTableBase
                        columns={cropRequestPricesList.tableHeaderData}
                        data={cropRequestPricesList.tableRowsData}
                        tableConfig={tableConfig}
                    />
                </CardBody>
            </Card>
        </Col>
    );
};

CropRequestPricesList.propTypes = {
    cropRequestPricesListTableData: PropTypes.shape({
        tableHeaderData: PropTypes.arrayOf(PropTypes.shape({
            key: PropTypes.string,
            name: PropTypes.string,
        })),
        tableRowsData: PropTypes.arrayOf(PropTypes.shape()),
    }).isRequired,
};

export default CropRequestPricesList;
